// src/AlignLeftIcon.tsx
import { jsx } from "react/jsx-runtime";
var AlignLeftIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "14",
    height: "10",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.25 9.12891H0.25V7.62891H9.25V9.12891ZM13.75 5.37891H0.25V3.87891H13.75V5.37891ZM9.25 1.62891H0.25V0.128906H9.25V1.62891Z",
        fill: "currentColor"
      }
    )
  }
);

export {
  AlignLeftIcon
};
